/** class à ajouter pour que le bouton fonctionne correctement
 *   sales_hubspot_tel_resp hs-cta-trigger-button hs-cta-trigger-button-207497911502
 *
 */

document.addEventListener("DOMContentLoaded", function () {
  let buttonsCTA = document.querySelectorAll(".sales_hubspot_tel_resp");
  if (buttonsCTA.length > 0) {
    buttonsCTA.forEach((button) => {
      if (window.innerWidth <= 768) {
        button.classList.remove(
          "hs-cta-trigger-button",
          "hs-cta-trigger-button-207497911502"
        );
        button.href = "tel:+33805034304";
      } else {
        button.href = "";
      }
    });
  }
});
